import { SimpleBaseHotspot } from '../../base/SimpleBaseHotspot';
/***
 * Represents a hotspot with background and image in the center.
 */
export class ImageHotspot {
    constructor(position, label, hasTilt, _iconBundle, assetUrls) {
        this.updateIcon = (iconId, hasTilt) => {
            this._image.updateIcon(iconId, hasTilt);
            this._background.updateBackgroundImage({
                url: hasTilt
                    ? this._assetsUrls.sceneLinkDefaultBackgroundUrlTilted
                    : this._assetsUrls.sceneLinkDefaultBackgroundUrl,
                width: hasTilt ? 127.59 : 70,
                height: hasTilt ? 48.11 : 70,
            });
        };
        this.updateOnClick = (handler) => {
            this._image.updateOnClick(handler);
            this._background.updateOnClick(handler);
        };
        this.updateSceneCoordinates = (sceneCoordinates) => {
            this._background.updateSceneCoordinates(sceneCoordinates);
            this._image.updateSceneCoordinates(sceneCoordinates);
        };
        this.updateVirtualTourPosition = (virtualTourPosition) => {
            this._background.updateVirtualTourPosition(virtualTourPosition);
            this._image.updateVirtualTourPosition(virtualTourPosition);
        };
        this.updateIsDragAndDropAllowed = (isAllowed) => {
            this._background.updateIsDragAndDropAllowed(isAllowed);
            this._image.updateIsDragAndDropAllowed(isAllowed);
        };
        this.updateDestinationLabel = (destinationLabel) => {
            this._background.updateLabel(destinationLabel);
        };
        this.lookTo = () => {
            this._image.lookTo();
        };
        this.attach = (virtualTour) => {
            this._background.attach(virtualTour);
            this._image.attach(virtualTour);
        };
        this.detach = () => {
            this._background.detach();
            this._image.detach();
        };
        this._assetsUrls = assetUrls;
        this._background = new SimpleBaseHotspot(position, 0, _iconBundle);
        this._background.updateBackgroundImage({
            url: hasTilt ? assetUrls.sceneLinkDefaultBackgroundUrlTilted : assetUrls.sceneLinkDefaultBackgroundUrl,
            width: hasTilt ? 127.59 : 70,
            height: hasTilt ? 48.11 : 70,
        });
        this._background.onBeingDragged = (newSceneCoordinates) => {
            this._image.updateSceneCoordinates(newSceneCoordinates);
        };
        this._background.updateLabel(label !== null && label !== void 0 ? label : null);
        this._image = new SimpleBaseHotspot(position, 1, _iconBundle);
        this._image.updateIcon('up', hasTilt);
        this._image.onBeingDragged = (newSceneCoordinates) => {
            this._background.updateSceneCoordinates(newSceneCoordinates);
        };
    }
}
